import styled from "styled-components"
import { Image } from "../../../image.component"
export const StyledGalleryContainer = styled.div`
  background: linear-gradient(
    to bottom,
    ${({ theme }) => theme.color.kickstarterBackgroundPrimary} 20%,
    #fff 20.001%
  );
  padding-top: 3em;

  @media (min-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    background: linear-gradient(
      to bottom,
      ${({ theme }) => theme.color.kickstarterBackgroundPrimary} 45%,
      #fff 45.001%
    );
    margin-bottom: 50px;
    padding-top: 250px;
  }
`

export const StyledGalleryWrapper = styled.div`
  width: 100%;
  height: 920px;
  img {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    height: 375px;
  }
`

export const StyledGatsbyImage = styled(Image)`
  width: 100%;
  height: 100%;
  img {
    object-fit: cover;
    object-position: bottom center;
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    height: 100%;
  }
`
